const data = [
  {
    info:
      'Personalized variables can be used through dynamic attributes that are unique for each learner.',
    buttonText: 'Dynamic Attributes',
  },
  {
    info:
      'You can set the gateway for how learners access your learning path. If there is no gateway, there will be no login, and therefore, their name and surname cannot be collected.',
    buttonText: 'Learners’ Access',
  },
  {
    info:
      'You can add your logo or change it. This logo also will appear in the landing page title area.',
    buttonText: 'Change Logo',
  },
]

export default data
